import { Button, FAIconName, Image, Text } from "@/ui/core";
import { BaseCard, VStack } from "@/ui/layout";
import { isNotNilNotEmpty } from "@/utils/shared.utils";
import { joinTestIDs } from "@/utils/string.util";

type CardSide = "back" | "front";

interface InsuranceOverviewCardProps {
  cardSide: CardSide;
  imageUrl?: string;
  onPress: () => void;
  testID: string;
}

const InsuranceOverviewCard = ({
  cardSide,
  imageUrl,
  onPress,
  testID,
}: InsuranceOverviewCardProps) => {
  const baseTestID = joinTestIDs(testID, cardSide);

  const cardTitle = cardSide === "front" ? "Front of card" : "Back of card";
  const buttonTitle = imageUrl ? "Replace" : "Add";
  const buttonIconName = imageUrl ? FAIconName.Refresh : FAIconName.Plus;
  const cardPaddingVertical = imageUrl ? 0 : 18;

  return (
    <BaseCard isBorderDashed={!imageUrl} testID={baseTestID}>
      <VStack
        alignItems="center"
        gap={8}
        paddingHorizontal={0}
        paddingVertical={cardPaddingVertical}
      >
        <Text testID={joinTestIDs(baseTestID, "title")} variant="bodyMedium">
          {cardTitle}
        </Text>
        {isNotNilNotEmpty(imageUrl) && (
          <Image
            contentFit="cover"
            size={{ height: 180, width: "100%" }}
            testID={baseTestID}
            uriSource={imageUrl}
          />
        )}
        <Button
          leftIcon={buttonIconName}
          onPress={onPress}
          size="small"
          testID={joinTestIDs(baseTestID, "add-image")}
          title={buttonTitle}
          variant="tertiary"
        />
      </VStack>
    </BaseCard>
  );
};

export type { CardSide };
export default InsuranceOverviewCard;
